<template>
  
  <div
    class="dark:block p-px dark:bg-[#3f1668] rounded-xl h-full"
  >
    <div
      class="text-left p-5 rounded-xl dark:bg-[var(--bg-case-studies-cards)] dark:rounded-xl dark:hover:[box-shadow:0_.0625rem_.75rem_0_rgba(38,57,82,.2)] dark:[box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,.08)] transition-all duration-500 h-full"
    >
      <NuxtImg
        :src="img"
        :alt="alt ?? 'Service Icon'"
        :width="width"
        :height="height"
        class="max-h-[64px]"
        loading="lazy"
        format="webp"
      />
      <h3 class="text-xl font-bold mt-4">{{ props.title }}</h3>
      <p class="mt-2 leading-8">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  img: {
    type: String,
    required: true,
  },
  alt: String,
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    default: 64,
  },
  height: {
    type: Number,
    default: 64,
  },
});
</script>

<style lang="scss" scoped></style>
